import type { OkrPerson } from "./types";

export function personById(people: readonly OkrPerson[]): Map<string, OkrPerson> {
  return new Map(people.map((person) => [person.id, person]));
}

export function personDisplayName(
  peopleById: Map<string, OkrPerson>,
  personId: string | null | undefined,
): string {
  if (!personId) return "—";
  return peopleById.get(personId)?.displayName ?? "—";
}

export function visibleDirectoryPeople(
  people: readonly OkrPerson[],
  visibility: { showArchived: boolean; showSuspended: boolean },
): OkrPerson[] {
  return people.filter((person) => {
    if (person.isArchived && !visibility.showArchived) return false;
    if (person.isSuspended && !visibility.showSuspended) return false;
    return true;
  });
}

export function directoryPersonStatus(person: OkrPerson): "active" | "archived" | "suspended" {
  if (person.isArchived) return "archived";
  if (person.isSuspended) return "suspended";
  return "active";
}
